import React, { useCallback, useEffect, useMemo, useState } from 'react';
import {
  Box,
  ButtonBase,
  Checkbox,
  Dialog,
  FormControlLabel,
  IconButton,
  InputBase,
  makeStyles,
  TextField,
  Typography,
} from '@material-ui/core';
import { KeyboardDatePicker } from '@material-ui/pickers';
import _ from 'lodash';
import moment from 'moment';
import { useSelector } from 'react-redux';
import * as Yup from 'yup';
import { bedStatusAPI, systemAPI, eadmissionAPI } from '../../../../../apis';
import { AutoCompleteInput, AutoCompleteSelect, KeyboardTimeInput } from '../../../../../components';
import { AddIcon, CloseIcon, DateIcon, NoticeIcon, AcceptIcon } from '../../../../../components/Icon';
import ElderlyHomeInfo from '../../../../../components/ElderlyHomeInfo';
import { i18n } from '../../../../../language';
import { classNames, initValue } from '../../../../../utils';
import { bsMlookupListFunc } from '../../../bsEnumeration';
import AddTextInput from '../../AddTextInput';
import { baseCssBooking, baseCssOccupieddischarge } from '../baseCss';
import { checkSubmitData } from '../../../../../utils/check';
import MdroInfo from '../../../../../components/MdroInfo';
import Text from '../../../../../components/Text';
import MyAlert from '../../../../../components/Alert';
import { hospitalWardListFunc } from '../../../../../utils/hospitalWardList';
import { bsAttentionFunc } from '../../../bsAttention';
import AutoCompleteMultiCheckbox2 from '../../../../../components/AutoCompleteMultiCheckbox2';
import TransferConfirmation from '../TransferConfirmation';
import { encryptHkid, getTransferInOutAdmissionTypeList, isNotEmptyArray } from '../../../../../utils/newBedStatusUtil';
import AutoCompleteInput2 from '../../../../../components/AutoCompleteInput2';
import CmsAlert, { CMS_ALERT_ICON_VARIANT } from '../../../../../components/CmsAlert';
import { bedP } from '../../../bsApp';

const useStyles = makeStyles((theme) => ({
  chineseNameInput: {
    '& .MuiInputBase-input': {
      fontFamily: 'HA_MingLiu, NotoSans-Medium, sans-serif !important',
    },
  },
  textField: {
    borderRadius: '0.625rem',
    marginBottom: '0.571rem',
    border: 'solid 1px #e4e7eb',
    padding: '0 1rem',
    backgroundColor: '#fff',
    '& .MuiInputBase-root': {
      fontFamily: 'NotoSans-Medium',
      fontSize: '1rem',
      color: '#2e4469',
      lineHeight: '1.8rem',
    },
    '& :before': {
      content: 'none',
    },
    '& :after': {
      content: 'none',
    },
  },
  dialog: {
    '& .MuiPaper-root': {
      // width: '80%',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      background: 'transparent',
      boxShadow: 'unset',
    },
  },
  root: {
    width: '100%',
    maxWidth: '100rem',
    display: 'flex',
    borderRadius: '0.625rem',
    boxShadow: '0 -2px 21px 0 rgba(30, 56, 140, 0.18)',
    backgroundColor: '#fff',
    background: '#fff',
    height: '100%',
    overflow: 'auto',
    minWidth: '100%',
    flexDirection: 'column',
  },
  grapText: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: '#c0c6cb',
  },
  keyboardTimeInput: {
    paddingRight: '0',
    '& .MuiFormControl-root': {
      display: 'flex',
      justifyContent: 'center',
    },
  },
  multilineText: {
    borderRadius: '0.625rem',
    border: 'solid 1px #e4e7eb',
    padding: '0 1rem',
    '& .MuiInputBase-root': {
      fontFamily: 'NotoSans-Medium',
      fontSize: '1rem',
      color: '#2e4469',
      lineHeight: '1.8rem',
    },
    '& :before': {
      content: 'none',
    },
    '& :after': {
      content: 'none',
    },
  },
  addIcon: {
    width: '1.125rem',
    height: '1.125rem',
    color: '#538fff',
    marginRight: '0.813rem',
  },
  addRemarks: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    fontWeight: '500',
    color: '#538fff',
  },
  remarks: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    fontWeight: '500',
    color: '#2e4469',
  },
  xing: {
    color: '#ff0300',
    padding: '0 2px',
    fontSize: '1rem',
    lineHeight: '1rem',
  },
  assignedBedNo: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    fontWeight: '500',
    color: '#2e4469',
  },
  assignedBedNoValue: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    fontWeight: '500',
    color: '#7d86a9',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignContent: 'center',
    alignItems: 'center',
    padding: '0 1.53rem',
  },
  remaksText: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1.125rem',
    fontWeight: '500',
    color: '#2e4469',
    marginLeft: '0.688rem',
  },
  keyboardDatePicker: {
    paddingRight: '0',
  },
  dateIcon: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  genderBtn: {
    width: '50%',
    height: '3.5rem',
  },
  genderBtnM: {
    width: '50%',
    height: '3.5rem',
  },
  genderBtnF: {
    width: '50%',
    height: '3.5rem',
  },
  gender: {
    flexBasis: 'unset',
  },
  datepicker: {
    '& *': {
      padding: '0',
      margin: '0',
      border: '0',
    },
    '& .MuiInputBase-root': {
      fontFamily: 'NotoSans-Medium',
      color: '#2e4469',
      height: '3.5rem',
      lineHeight: '3.5rem',
      display: 'flex',
      justifyContent: 'center',
      alignContent: 'center',
      borderRadius: '0.625rem',
      border: 'solid 1px #e4e7eb',
      backgroundColor: '#fff',
      padding: '0 1.25rem',
      fontSize: '1rem',
    },
    '& .MuiInputBase-input': {
      height: '3.5rem',
      lineHeight: '3.5rem',
    },
    '& :focus': {
      backgroundColor: 'unset',
    },
    '& :before': {
      content: 'none',
    },
    ':before': {
      content: 'none !important',
    },
    '& :after': {
      content: 'none',
    },
  },
  labelError: {
    color: '#f44336',
  },
  inputError: {
    border: '1px solid #f44336',
  },
  errorMsg: {
    margin: '3px 0.825rem 0 0.825rem',
    color: '#f44336',
    fontFamily: 'NotoSans-Medium',
    fontWeight: '500',
  },
  addTextInput: {
    minHeight: '13.063rem',
    height: 'unset',
  },
  covidDetail: {
    backgroundColor: '#f5faff',
    border: '1px solid #538fff',
    borderRadius: '12px',
    padding: '1rem 1rem 0.75rem',
    margin: '0.688rem  0 2rem 0',
  },
  covidDetailTitle: {
    fontSize: '1rem',
    color: '#1973e6',
    fontFamily: 'NotoSans-Bold',
    fontWeight: 'bold',
    marginBottom: '1rem',
  },
  buttonBase: {
    '&.MuiButtonBase-root.Mui-disabled': {
      backgroundColor: '#c0c6cb',
    },
  },
  buttonRetrieve: {
    '&.MuiButtonBase-root.Mui-disabled': {
      backgroundColor: '#c0c6cb',
      borderColor: '#c0c6cb',
      color: '#fff',
    },
  },
  disabledStyle: {
    '& .MuiInputBase-root': {
      backgroundColor: '#f5f5f5',
    },

    '& .MuiInputBase-root.Mui-disabled': {
      backgroundColor: '#f5f5f5',
    },
    // '& .Mui-disabled': {
    //   backgroundColor: '#f5f5f5',
    // },
  },
  bgYellow: {
    backgroundColor: '#fff3bb',
    borderRadius: '15px',
    padding: '0.5rem 0.857rem',
  },
  message: {
    padding: '1rem',
    borderRadius: '12px',
    color: '#000',
    marginBottom: '2rem',
  },
  messageRed: {
    backgroundColor: '#fff0f0',
  },
  messageYellow: {
    backgroundColor: '#fff3bb',
  },
  messageGreen: {
    backgroundColor: '#e9faf6',
  },
  messageStatus: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '1rem',
    fontFamily: 'NotoSans-Bold',
    fontWeight: 'bold',
  },
  messageStatusRed: {
    color: '#ff0300',
  },
  messageStatusYellow: {
    color: '#c54e17',
  },
  messageStatuGreen: {
    color: '#34c759',
  },
  messageTitle: {
    fontSize: '0.875rem',
    fontFamily: 'NotoSans-Medium',
    fontWeight: '500',
    marginTop: '0.5rem',
  },
  messageText: {
    fontSize: '1rem',
    fontFamily: 'NotoSans-Medium',
    marginTop: '0.5rem',
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-all',
  },
  messageIcon: {
    marginRight: '1rem',
  },
  inputBase: {
    '&.MuiInputBase-root.Mui-disabled': {
      backgroundColor: '#f5f5f5',
      color: '#3e3e3e',
    },
  },
  destSelect: {
    '& .MuiInputBase-input': {
      lineHeight: 'initial',
    },
  },
  checkbox: {
    '&.Mui-disabled': {
      '& .MuiIconButton-label': {
        backgroundColor: '#f5f5f5',
      },
    },
  },
  caseNoGroup: {
    backgroundColor: '#F5FAFF',
    borderRadius: '16px',
    display: 'flex',
    padding: '0.642rem 0.857rem',
    flex: 1,
    width: '49%',
    gap: '1.21rem',
  },
  retrieveGroup: {
    borderRadius: '16px',
    border: '1px solid #E4E7EB',
    padding: '12px',
  },
  elderlyHomeInfo: {
    marginTop: '0.62rem',
  },
}));

const P = {
  patienID: 'caseNo',
  hospitalCode: 'fromHospCode', // *
  name: 'patName',
  age: 'age',
  specialtyCode: 'eisSpecCd',
  gender: 'patGender',
  ward: 'fromWardLocation',
  bedNo: 'fromBedNo',
  date_time: 'targetArriveDtm',
  admissionType: 'admissionType',
  assignedBedNo: 'assignedBedNo',
  principleDiagnosis: 'principleDiagnosis',
  principleDiagnosisText: 'diagnosis',
  principleDiagnosisInputValue: 'principleDiagnosisInputValue',
  onVentilator: 'onVentilator',
  egPercent: 'ventilatorPrecentage',
  onOxygen: 'onOxygen',
  tracheotomy: 'tracheotomy',
  egL: 'oxygenLitre',
  airbornePrecaution: 'airbornePrecautionYn',
  dropletPrecaution: 'dropletPrecautionYn',
  contactPrecaution: 'contactPrecautionYn',
  reverseLsolation: 'reversePrecautionYn',
  covid19: 'covidPositiveYn',
  covidPositivePat: 'covidPositivePat',
  attention: 'attention',
  remarks: 'remark',
  date: 'date',
  time: 'time',
  admDtm: 'admDtm',
  status: 'status',
  counter: 'counter',
  covidDate: 'reportDtm',
  covidReportDtm: 'covidReportDtm',
  wardCd: 'wardCd',
  destHospCode: 'destHospCode',
  destWard: 'destWard',
  destWardId: 'destWardId',
  destSpecialty: 'destSpecialty',
  bedNoTransfer: 'bedNo',
  ccHosp: 'ccHosp',
  ccWardLocation: 'ccWardLocation',
  patientKey: 'patientKey',
  hkid: 'hkid',
  chiName: 'chiName',
  destWardLocation: 'destWardLocation',
};

const alertText = (value) => {
  if (value === 1) {
    return i18n.t('BEDSTATUS_NO_INFORMATION_IS_RETRIEVED');
  } else {
    return i18n.t('BEDSTATUS_RETRIEVE_SUCCESSFULLY');
  }
};

const saveBtnDisabled = (status) => status === 'C' || status === 'A' || status === 'D';

const handleInitRemark = (allData, covidPositivePatRemarks) => {
  if (allData?.[P.covidPositivePat]) {
    return `[nCoV] CT Value: ${allData?.[P.covidPositivePat]?.[0].ctValue}  ${
      allData?.[P.covidPositivePat]?.[0].covidDescription
    }`;
  } else if (covidPositivePatRemarks) {
    return '';
  } else {
    return allData?.[P.remarks] ?? '';
  }
};

const handleInitStatus = (allData, bsMlookupList) => {
  if (allData) {
    return initValue(allData?.[P.status]);
  } else {
    return bsMlookupListFunc.isTypeLookupValueExist(bsMlookupList, 'bs_book_status', 'P') ? 'P' : '';
  }
};

const initTempSchema = (newTemp, schema) => ({
  [P.name]: newTemp[P.name] ? schema[P.name] : null,
  [P.chiName]: newTemp[P.chiName] ? schema[P.chiName] : null,
  [P.gender]: newTemp[P.gender] ? schema[P.gender] : null,
  [P.age]: newTemp[P.age] !== null ? schema[P.age] : null,
  [P.date]: newTemp[P.admDtm] ? schema[P.date] : null,
  [P.time]: newTemp[P.admDtm] ? schema[P.time] : null,
});

const initMoment = (value) => {
  if (value) {
    return moment(value);
  }
  return null;
};

const initRemark = (props) => {
  if (props) {
    return `[nCoV] CT Value: ${props?.[0].ctValue}  ${props?.[0].covidDescription}`;
  } else {
    return '';
  }
};

export default function TransferOutPop({
  closePop,
  title,
  open,
  allData,
  saveHandle,
  bsMlookupList,
  disabledData,
  transferOutSchema,
  sendBtn = false,
  transferOutDetail,
  bsMlookupListStatus,
  disabledStatus,
  covidPositivePatRemarks = false,
}) {
  const [BsDiagnosisList, setBsDiagnosisList] = useState(null);
  const [BsDigKeyword, setBsDigkeyword] = useState(null);
  const [BsRemarkList, setBsRemarkList] = useState(null);
  const loginInfo = useSelector((state) => state.loginInfo);
  const [BsHospcodeList, setBsHospcodeList] = useState(null);
  const [BsAttentionList, setBsAttentionList] = useState(null);
  const [SysHospitalWardList, setSysHospitalWardList] = useState(null);
  // const [amdDateIsChecked, setAmdDateIsChecked] = useState(!allData || allData?.[P.date_time] ? false : true);
  const [amdDateIsChecked, setAmdDateIsChecked] = useState(false);
  const [BookingDataFormat, setBookingDataFormat] = useState({});
  const initSchema = useCallback(
    (transferOutSchema, amdDateIsChecked) => ({
      [P.patienID]: transferOutSchema?.caseNo
        ? ''
        : Yup.string().test(
            'either-patientID-or-hkid',
            'Either Case No. or HKID / Doc. No. must be filled in.',
            function (value) {
              const hkidVal = BookingDataFormat?.[P.hkid];
              const hasValue = value && value.trim().length > 0;
              const hasHkid = hkidVal && hkidVal.trim().length > 0;
              if (hasValue) return true;
              if (hasHkid) return true;

              return false;
            }
          ),
      [P.hkid]: transferOutSchema?.hkid
        ? ''
        : Yup.string().test(
            'either-patientID-or-hkid',
            'Either Case No. or HKID / Doc. No. must be filled in.',
            function (value) {
              const patientIDVal = BookingDataFormat?.[P.patienID];
              const hasValue = value && value.trim().length > 0;
              const hasPatientID = patientIDVal && patientIDVal.trim().length > 0;
              if (hasValue) return true;
              if (hasPatientID) return true;

              return false;
            }
          ),
      [P.hospitalCode]: transferOutSchema?.hospitalCode
        ? ''
        : Yup.string()
            .max(10)
            .required(i18n.t('SETTING_IS_A_REQUIRED_FIELD', { value: i18n.t('BEDSTATUS_HOSPITAL_CODE') })),
      [P.name]: transferOutSchema?.name
        ? ''
        : Yup.string().required(i18n.t('SETTING_IS_A_REQUIRED_FIELD', { value: i18n.t('BEDSTATUS_NAME') })),
      [P.age]: transferOutSchema?.age
        ? ''
        : Yup.string().required(i18n.t('SETTING_IS_A_REQUIRED_FIELD', { value: i18n.t('BEDSTATUS_AGE') })),
      [P.gender]: transferOutSchema?.gender
        ? ''
        : Yup.string().required(i18n.t('SETTING_IS_A_REQUIRED_FIELD', { value: i18n.t('BEDSTATUS_GENDER') })),
      [P.date]: amdDateIsChecked
        ? Yup.date().nullable()
        : Yup.date()
            .required(i18n.t('SETTING_IS_A_REQUIRED_FIELD', { value: i18n.t('BEDSTATUS_DATE') }))
            .typeError(i18n.t('BEDSTATUS_INVALID_DATE_FORMAT')),
      [P.time]: amdDateIsChecked
        ? Yup.date().nullable()
        : Yup.date()
            .required(i18n.t('SETTING_IS_A_REQUIRED_FIELD', { value: i18n.t('BEDSTATUS_TIME') }))
            .typeError(i18n.t('BEDSTATUS_INVALID_DATE_FORMAT')),
      [P.admissionType]: Yup.string().required(
        i18n.t('SETTING_IS_A_REQUIRED_FIELD', { value: i18n.t('BEDSTATUS_ADMISSION_TYPE') })
      ),
      // [P.wardCd]: Yup.string().required(i18n.t('SETTING_IS_A_REQUIRED_FIELD', { value: 'Assigned Ward Code' })),
      // [P.assignedBedNo]: Yup.string().required(
      //   i18n.t('SETTING_IS_A_REQUIRED_FIELD', { value: i18n.t('BEDSTATUS_ASSIGNED_BED_NO') })
      // ),
      // [P.principleDiagnosis]: BookingDataFormat[P.principleDiagnosis] ? Yup.string().min(3) : null,
      [P.status]: transferOutSchema?.status
        ? ''
        : Yup.string().required(i18n.t('SETTING_IS_A_REQUIRED_FIELD', { value: i18n.t('BEDSTATUS_STATUS') })),
      [P.attention]: Yup.string().max(255).nullable(),
      [P.remarks]: Yup.string().max(255).nullable(),
      [P.destHospCode]: Yup.string().required(
        i18n.t('SETTING_IS_A_REQUIRED_FIELD', { value: i18n.t('BEDSTATUS_DEST_HOSPITAL') })
      ),
      [P.destWardId]: Yup.string().required(
        i18n.t('SETTING_IS_A_REQUIRED_FIELD', { value: i18n.t('BEDSTATUS_DEST_WARD') })
      ),
      // [P.principleDiagnosisText]: Yup.string().required(
      //   i18n.t('SETTING_IS_A_REQUIRED_FIELD', { value: i18n.t('BEDSTATUS_PRINCIPLE_DIAGNOSIS') })
      // ),
      // [P.hkid]: Yup.string().nullable(),
      [P.chiName]: Yup.string().nullable(),
      [P.destWardLocation]: Yup.string().required(
        i18n.t('SETTING_IS_A_REQUIRED_FIELD', { value: 'Dest. Ward Location' })
      ),
    }),
    [transferOutSchema, amdDateIsChecked, BookingDataFormat]
  );

  const schema = initSchema(transferOutSchema, amdDateIsChecked);

  const requestHttp = async () => {
    try {
      const { result } = await systemAPI.getSysHospitalWardList({
        hospitalId: loginInfo.hospitalId,
        wardId: loginInfo.wardId,
      });
      Array.isArray(result) && setSysHospitalWardList(result);
    } catch {}

    try {
      const { result } = await bedStatusAPI.getBsAttentionList();
      Array.isArray(result) && setBsAttentionList(result);
    } catch {}

    try {
      const { result } = await bedStatusAPI.getIpasHospList();
      Array.isArray(result) && setBsHospcodeList(result);
    } catch {}

    try {
      const getBsRemarkList = await bedStatusAPI.getBsRemarkList({ wardId: loginInfo.wardId, isActive: 1 });
      setBsRemarkList(getBsRemarkList?.result?.data);
    } catch {}

    // try {
    //   const { result } = await bedStatusAPI.getDefaultAdmissionTime();
    //   const defaultTime = result?.transferTimeDefault ? moment(result?.transferTimeDefault, 'HH:mm:ss') : null;
    //   if (!allData) {
    //     setBookingDataFormat((prev) => ({
    //       ...prev,
    //       [P.date]: defaultTime ? null : moment(),
    //       [P.time]: defaultTime ?? moment(),
    //     }));
    //   }
    // } catch (error) {
    //   console.log(error);
    // }
  };
  useEffect(() => {
    (async () => {
      await requestHttp();
    })();
  }, []);

  const baseClass = baseCssOccupieddischarge();

  const handlerBsDiagnosisListFetch = React.useCallback(async () => {
    if (BsDigKeyword !== null && typeof BsDigKeyword === 'string' && BsDigKeyword.length >= 3) {
      try {
        const getBsDiagnosisList = await bedStatusAPI.getBsDiagnosisList(
          {
            wardId: loginInfo.wardId,
            isActive: 1,
            pageNo: 1,
            pageSize: 200,
            keyword: BsDigKeyword,
          },
          { isHideLoading: true }
        );
        setBsDiagnosisList(getBsDiagnosisList?.result?.data);
      } catch {}
    }
  }, [BsDigKeyword]);

  const HandlerOnChangeBsDigKeyword = React.useCallback(
    _.debounce((text) => {
      setBsDigkeyword(text);
    }, 800),
    []
  );

  useEffect(() => {
    handlerBsDiagnosisListFetch();
  }, [handlerBsDiagnosisListFetch]);

  useEffect(() => {
    if (SysHospitalWardList && Array.isArray(BsHospcodeList) && !allData) {
      const hospCode = hospitalWardListFunc.getIpasFirstHospitalCode(
        SysHospitalWardList,
        loginInfo.hospitalId,
        loginInfo.wardId
      );
      if (BsHospcodeList.includes(hospCode)) {
        setBookingDataFormat({ ...BookingDataFormat, [P.hospitalCode]: hospCode });
      } else if (BsHospcodeList.length > 0) {
        setBookingDataFormat({ ...BookingDataFormat, [P.hospitalCode]: BsHospcodeList[0] });
      }
    }
  }, [SysHospitalWardList, BsHospcodeList]);
  useEffect(() => {
    setBookingDataFormat({
      [P.patienID]: initValue(allData?.[P.patienID]),
      [P.hospitalCode]: allData?.[P.hospitalCode] ? allData?.[P.hospitalCode] : initValue(allData?.[P.ccHosp]),
      [P.name]: initValue(allData?.[P.name]),
      [P.age]: initValue(allData?.[P.age]),
      [P.specialtyCode]: initValue(allData?.[P.specialtyCode]),
      [P.gender]: initValue(allData?.[P.gender], 'M'),
      [P.ward]: allData?.[P.ward] ? allData?.[P.ward] : initValue(allData?.[P.ccWardLocation]),
      [P.bedNo]: allData?.[P.bedNo] ? allData?.[P.bedNo] : initValue(allData?.[P.bedNoTransfer]),
      // [P.date]: !amdDateIsChecked ? moment(allData?.[P.date_time]) : null,
      // [P.time]: !amdDateIsChecked ? moment(allData?.[P.date_time]) : null,
      [P.date]: allData?.[P.date_time] ? moment(allData?.[P.date_time]) : moment(),
      [P.time]: allData?.[P.date_time] ? moment(allData?.[P.date_time]) : moment(),
      [P.admissionType]: initValue(allData?.[P.admissionType]),
      // [P.assignedBedNo]: allData?.[P.assignedBedNo] ?? '',
      [P.principleDiagnosis]: Array.isArray(allData?.[P.principleDiagnosis]) ? allData?.[P.principleDiagnosis] : [],
      [P.principleDiagnosisText]: initValue(allData?.[P.principleDiagnosisText]),
      [P.principleDiagnosisInputValue]: '',
      [P.onVentilator]: initValue(allData?.[P.onVentilator]),
      [P.egPercent]: initValue(allData?.[P.egPercent]),
      [P.onOxygen]: allData?.[P.onOxygen],
      [P.tracheotomy]: allData?.[P.tracheotomy],
      [P.egL]: initValue(allData?.[P.egL]),
      [P.airbornePrecaution]: allData?.[P.airbornePrecaution],
      [P.dropletPrecaution]: allData?.[P.dropletPrecaution],
      [P.contactPrecaution]: allData?.[P.contactPrecaution],
      [P.reverseLsolation]: allData?.[P.reverseLsolation],
      [P.attention]: initValue(allData?.[P.attention]),
      // [P.remarks]: allData?.[P.remarks] ?? '',
      [P.remarks]: handleInitRemark(allData, covidPositivePatRemarks),
      [P.status]: handleInitStatus(allData, bsMlookupList),
      [P.covid19]: initValue(allData?.[P.covid19], 0),
      [P.covidDate]: allData?.[P.covidReportDtm] ? moment(allData?.[P.covidReportDtm]) : moment(),
      [P.counter]: allData?.[P.covidReportDtm]
        ? Math.round((moment().valueOf() - allData?.[P.covidReportDtm]) / (24 * 60 * 60 * 1000))
        : 0,
      [P.wardCd]: initValue(allData?.[P.wardCd]),
      [P.assignedBedNo]: initValue(allData?.[P.assignedBedNo]),
      [P.destHospCode]: initValue(allData?.[P.destHospCode]),
      [P.destWard]: initValue(allData?.[P.destWard]),
      [P.destSpecialty]: initValue(allData?.[P.destSpecialty]),
      [P.destWardId]: initValue(allData?.[P.destWardId]),
      [P.hkid]: initValue(allData?.[P.hkid]),
      [P.chiName]: initValue(allData?.[P.chiName]),
      [P.destWardLocation]: initValue(allData?.[P.destWardLocation]),
    });
  }, []);
  // Redirect to other ward Button
  const redirectToOtherWardHandler = () => {
    setBookingDataFormat({
      ...BookingDataFormat,
      [P.destHospCode]: '',
      [P.destWard]: '',
      [P.destWardId]: '',
      [P.wardCd]: '',
      [P.assignedBedNo]: '',
      [P.destSpecialty]: '',
      [P.status]: 'P',
    });
    setStatusDL(false);
  };
  const [list] = useState(bsMlookupListStatus);
  const listOption = useMemo(() => {
    let listStatus = [];
    const allStatus = bsMlookupListFunc.getBSBookStatusAddTranslate(bsMlookupList);
    if (_.isArray(list)) {
      if (allData?.[P.status] && !['P', 'A'].includes(allData?.[P.status]) && BookingDataFormat[P.status] !== 'P') {
        listStatus = [...allStatus, { text: i18n.t('BEDSTATUS_RECV_WARD_READY'), value: 'RWR' }];
      } else if (allData?.[P.status] === 'DL') {
        listStatus.push({ text: i18n.t('BEDSTATUS_PENDING'), value: 'P' });
      } else if (allData?.[P.status] === 'A') {
        listStatus.push(
          { text: i18n.t('BEDSTATUS_ACCEPTED'), value: 'A' },
          { text: i18n.t('BEDSTATUS_DELETED'), value: 'D' }
        );
      } else {
        listStatus = _.map(list, (item, index) => {
          return { text: item.lookUpName, value: item.lookUpValue };
        });
      }
    }
    return listStatus;
  }, [list, bsMlookupList, BookingDataFormat]);

  const counter = useMemo(() => {
    return Math.round((moment().valueOf() - BookingDataFormat?.[P.covidDate]) / (24 * 60 * 60 * 1000));
  }, [BookingDataFormat[P.covidDate], allData?.[P.covidReportDtm]]);

  const [errorMsg, setErrorMsg] = useState(null);

  const [PatientRetrieve, setPatientRetrieve] = useState(null);
  const patientStatusData = allData ?? PatientRetrieve;
  const postPatientRetrieve = async (caseNo, hospCode, hkid) => {
    try {
      const { result } = await bedStatusAPI.postPatientRetrieve({ caseNo, hospCode, hkid });
      setPatientRetrieve(result);
      result === null && showMyAlert(1);
    } catch (error) {
      console.log(`------${error}------`);
    }
  };

  useEffect(() => {
    (async () => {
      if (PatientRetrieve) {
        const newTemp = {
          [P.hospitalCode]: PatientRetrieve?.ccHosp ?? '',
          [P.ward]: initValue(PatientRetrieve?.ccWardLocation),
          [P.bedNo]: initValue(PatientRetrieve?.bedNo),
          [P.specialtyCode]: initValue(PatientRetrieve?.[P.specialtyCode]),
          [P.patienID]: initValue(PatientRetrieve?.[P.patienID]),
          [P.gender]: PatientRetrieve?.[P.gender],
          [P.name]: initValue(PatientRetrieve?.[P.name]),
          [P.chiName]: initValue(PatientRetrieve?.[P.chiName]),
          [P.age]: initValue(PatientRetrieve?.[P.age]),
          // [P.date]: moment(PatientRetrieve?.[P.admDtm]).isValid() ? moment(PatientRetrieve?.[P.admDtm]) : null,
          // [P.time]: moment(PatientRetrieve?.[P.admDtm]).isValid() ? moment(PatientRetrieve?.[P.admDtm]) : null,
          [P.attention]: bsAttentionFunc.getSortNameStr(BsAttentionList, PatientRetrieve?.[P.attention]),
          [P.reverseLsolation]: PatientRetrieve?.[P.reverseLsolation],
          [P.dropletPrecaution]: PatientRetrieve?.[P.dropletPrecaution],
          [P.airbornePrecaution]: PatientRetrieve?.[P.airbornePrecaution],
          [P.contactPrecaution]: PatientRetrieve?.[P.contactPrecaution],
          [P.covid19]: PatientRetrieve?.[P.covid19],
          [P.covidDate]: initMoment(PatientRetrieve?.[P.covidPositivePat]?.[0]?.[P.covidDate]),
          [P.counter]: Math.round(
            (moment().valueOf() - PatientRetrieve?.[P.covidPositivePat]?.[0]?.[P.covidDate]) / (24 * 60 * 60 * 1000)
          ),

          [P.remarks]: initRemark(PatientRetrieve?.[P.covidPositivePat]),
        };
        if (
          Object.keys(newTemp).find((item) => {
            return PatientRetrieve[item] !== null;
          })
        ) {
          showMyAlert(2);
        } else {
          showMyAlert(1);
        }
        setBookingDataFormat({
          ...BookingDataFormat,
          ...newTemp,
        });
        try {
          const temp = initTempSchema(newTemp, schema);
          await checkSubmitData(Yup.object().shape(temp), newTemp);
          const errorTemp = {};
          Object.keys(temp).forEach((item) => {
            if (temp[item]) {
              errorTemp[item] = null;
            }
          });
          setErrorMsg({ ...errorMsg, ...errorTemp });
        } catch (e) {
          setErrorMsg({ ...errorMsg, ...e });
        }
      }
    })();
  }, [PatientRetrieve]);
  const retrieveClick = async () => {
    try {
      if (!BookingDataFormat[P.hkid]) {
        await checkSubmitData(
          Yup.object().shape({ [P.patienID]: schema[P.patienID], [P.hkid]: schema[P.hkid] }),
          BookingDataFormat
        );
      }
      setErrorMsg({ ...errorMsg, [P.patienID]: null, [P.hkid]: null });
      await postPatientRetrieve(
        BookingDataFormat[P.patienID],
        BookingDataFormat[P.hospitalCode],
        BookingDataFormat[P.hkid]
      );
    } catch (e) {
      setErrorMsg({ ...errorMsg, ...e });
    }
  };

  const BsDiagnosisListFrom = useMemo(() => {
    if (Array.isArray(BsDiagnosisList)) {
      return _.orderBy(
        _.map(BsDiagnosisList, (item) => {
          return { text: item.diagnosis, value: item.diagnosis };
        }),
        'text',
        'asc'
      );
    }
    return [];
  }, [BsDiagnosisList]);

  const patientKeyVal = useMemo(() => {
    let value = null;
    if (
      allData?.[P.patienID] === BookingDataFormat[P.patienID] &&
      allData?.[P.hospitalCode] === BookingDataFormat[P.hospitalCode]
    ) {
      if (PatientRetrieve?.patientKey) {
        value = PatientRetrieve?.patientKey;
      } else {
        value = allData?.patientKey;
      }
    } else if (PatientRetrieve?.patientKey) {
      value = PatientRetrieve?.patientKey;
    }

    return value;
  }, [
    PatientRetrieve?.patientKey,
    BookingDataFormat[P.patienID],
    allData?.[P.patienID],
    allData?.[P.hospitalCode],
    BookingDataFormat[P.hospitalCode],
  ]);

  const onChangeHandle = (type, key) => {
    return async (event) => {
      let temp;
      switch (type) {
        case 'text':
          setBookingDataFormat({ ...BookingDataFormat, [key]: event.target.value });
          break;
        case 'up_text':
          setBookingDataFormat({ ...BookingDataFormat, [key]: _.toUpper(event.target.value) });
          break;
        case 'select_hosp_code':
          setBookingDataFormat({ ...BookingDataFormat, [key]: _.toUpper(event) });
          break;
        case 'select_dest_hospital':
          setBookingDataFormat({
            ...BookingDataFormat,
            [key]: event,
            [P.destWardId]: '',
            [P.destWardLocation]: '',
          });
          break;
        case 'select_dest_unit':
          setBookingDataFormat({
            ...BookingDataFormat,
            [key]: event,
            [P.destWardLocation]: '',
          });
          break;
        case 'text_positive_integer':
          temp = parseInt(event.target.value);
          temp = isNaN(temp) ? '' : temp;
          // eslint-disable-next-line eqeqeq
          if (temp == '' || temp <= 120) {
            setBookingDataFormat({ ...BookingDataFormat, [key]: temp });
          }
          break;
        case 'integer':
          temp = parseInt(event.target.value);
          temp = isNaN(temp) ? '' : temp;
          setBookingDataFormat({ ...BookingDataFormat, [key]: temp });
          break;
        case 'select':
          setBookingDataFormat({ ...BookingDataFormat, [key]: initValue(event) });
          break;
        case 'date':
          try {
            await checkSubmitData(Yup.object().shape({ [key]: schema[key] }), { [key]: event });
            setErrorMsg({ ...errorMsg, [key]: null });
          } catch (e) {
            setErrorMsg({ ...errorMsg, ...e });
          }
          setBookingDataFormat({ ...BookingDataFormat, [key]: event });
          break;
        case 'check':
          setBookingDataFormat({ ...BookingDataFormat, [key]: Number(event.target.checked) });
          break;

        default:
          break;
      }
    };
  };

  const onGenderClick = (key, value) => {
    return () => {
      (async () => {
        await onChangeHandle('select', key)(value);
      })();
    };
  };

  const canelHandler = () => {
    closePop();
  };

  const onVentilatorList = () => {
    return [
      { text: '\u2002', value: null },
      ...bsMlookupListFunc.getTypeLookupFormat(bsMlookupList, 'bs_book_ventilator'),
    ];
  };
  const [, setAssignedWardCode] = useState([]);
  const [, setBedStatuswardCdlist] = useState();
  const [destHospitalOption, setDestHospitalOption] = useState([]);
  const getBsBedStatuswardCdlistApi = useCallback(async () => {
    try {
      if (BookingDataFormat[P.destWardId]) {
        const { result } = await bedStatusAPI.getBsBedStatuswardCdlist({ wardId: BookingDataFormat[P.destWardId] });
        let assignedWardCodeOption = [];
        assignedWardCodeOption = _.map(result, (item, index) => {
          return { text: item.wardCd, value: item.wardCd };
        });
        setBedStatuswardCdlist(result);
        setAssignedWardCode(assignedWardCodeOption);
      }
    } catch (error) {}
  }, []);

  const getBsBedStatusHospWardListApi = useCallback(async () => {
    try {
      const { result } = await eadmissionAPI.getHospWardList({ currentWardId: loginInfo?.wardId });
      const destHospOptions = _.map(result, (item) => ({
        ...item,
        text: item?.hospCode,
        value: item?.hospCode,
      }));
      setDestHospitalOption(destHospOptions);
    } catch (error) {}
  }, []);

  const destUnitOptions = useMemo(() => {
    const destUnitList =
      _.find(destHospitalOption, (item) => item?.value === BookingDataFormat[P.destHospCode])?.wards || [];
    const revampUnitList = _.map(destUnitList, (item) => ({
      ...item,
      text: item?.wardName,
      value: item?.wardId,
    }));
    return revampUnitList;
  }, [destHospitalOption, BookingDataFormat[P.destHospCode]]);

  const destWardLocationOptions = useMemo(() => {
    const destWardLocList =
      _.find(destUnitOptions, (item) => item?.value === BookingDataFormat[P.destWardId])?.wardLocations || [];
    const revampDestWardLocList = _.map(destWardLocList, (item) => ({
      text: item,
      value: item,
    }));
    // 只有一个选项的时候，自动选择这个dest ward
    if (revampDestWardLocList.length === 1) {
      (async () => {
        await onChangeHandle('select', P.destWardLocation)(revampDestWardLocList?.[0]?.value);
      })();
    }
    return revampDestWardLocList;
  }, [destUnitOptions, BookingDataFormat[P.destWardId]]);

  const destUnitName = useMemo(() => {
    return _.find(destUnitOptions, (item) => item?.value === BookingDataFormat[P.destWardId])?.wardName ?? '';
  }, [destUnitOptions, BookingDataFormat[P.destWardId]]);

  useEffect(() => {
    (async () => {
      await getBsBedStatuswardCdlistApi();
    })();
    (async () => {
      await getBsBedStatusHospWardListApi();
    })();
  }, [getBsBedStatuswardCdlistApi, getBsBedStatusHospWardListApi]);
  const [statusDL, setStatusDL] = useState(false);
  useEffect(() => {
    if (allData?.status === 'DL') {
      setStatusDL(true);
    }
  }, [allData?.status]);
  const remarkList = useMemo(() => {
    if (BsRemarkList) {
      return _.map(BsRemarkList, (item) => {
        return item.remark;
      });
    }
    return [];
  }, [BsRemarkList]);

  const baseClasses = baseCssBooking();
  const classes = useStyles();

  const getCheckLableClasses = (key) => {
    return errorMsg?.[key] ? classNames(baseClasses.labelText, classes.labelError) : baseClasses.labelText;
  };

  const getCheckInputClasses = (key) => {
    return errorMsg?.[key] ? classNames(baseClasses.inputText, classes.inputError) : baseClasses.inputText;
  };

  const focusCheck = (name) => {
    return async () => {
      try {
        if ([P.patienID, P.hkid].includes(name)) {
          await checkSubmitData(Yup.object().shape({ [P.patienID]: schema[P.patienID], [P.hkid]: schema[P.hkid] }), {
            [P.patienID]: BookingDataFormat[P.patienID],
            [P.hkid]: BookingDataFormat[P.hkid],
          });
          setErrorMsg({ ...errorMsg, [P.patienID]: null, [P.hkid]: null });
        } else {
          await checkSubmitData(Yup.object().shape({ [name]: schema[name] }), { [name]: BookingDataFormat[name] });
          setErrorMsg({ ...errorMsg, [name]: null });
        }
      } catch (e) {
        setErrorMsg({ ...errorMsg, ...e });
      }
    };
  };

  const [isMyAlert, setIsMyAlert] = useState(0);
  const closeMyAlert = () => {
    setIsMyAlert(0);
  };
  const showMyAlert = (value) => {
    setIsMyAlert(value);
    setTimeout(closeMyAlert, 1500);
  };

  const saveClick = async (deteleted) => {
    try {
      await checkSubmitData(Yup.object().shape(schema), BookingDataFormat);
      setErrorMsg(null);
      const saveValue = {
        ...allData,
        ...BookingDataFormat,
        [P.age]: Number(BookingDataFormat[P.age]),
        [P.attention]: BookingDataFormat[P.attention],
        [P.remarks]: BookingDataFormat[P.remarks],
        [P.date_time]: amdDateIsChecked
          ? null
          : moment(
              moment(BookingDataFormat[P.date], 'D/MM/yyyy').format('yyyy-MM-DD ') +
                BookingDataFormat[P.time].format('HH:mm:ss'),
              'yyyy-MM-DD HH:mm:ss'
            ).valueOf(),
        [P.covidReportDtm]: BookingDataFormat[P.covid19] ? moment(BookingDataFormat[P.covidDate]).valueOf() : null,
        [P.destWard]: destUnitName,
        // [P.patientKey]: PatientRetrieve?.patientKey && PatientRetrieve.patientKey,
        [P.patientKey]: patientKeyVal,
        [P.status]: initValue(deteleted, BookingDataFormat[P.status]),
        [P.hkid]: await encryptHkid(BookingDataFormat[P.hkid]),
      };
      if (typeof saveHandle === 'function') {
        saveHandle(saveValue);
      }
    } catch (errorMsg) {
      setErrorMsg(errorMsg);
    }
  };
  const deletedHandler = () => {
    (async () => {
      await saveClick('D');
    })();
  };
  const [transferConfirmation, setTransferConfirmation] = useState(false);
  const sendClick = async () => {
    try {
      await checkSubmitData(Yup.object().shape(schema), BookingDataFormat);
      setErrorMsg(null);
      setTransferConfirmation(true);
    } catch (errorMsg) {
      setErrorMsg(errorMsg);
    }
  };
  const closePopTransferConfirmation = () => {
    setTransferConfirmation(false);
  };

  const statusIsA = useMemo(() => allData?.status === 'A', [allData?.status]);

  const handleCheckAmdDate = (event) => {
    const isChecked = event.target.checked;
    setAmdDateIsChecked(isChecked);
    if (isChecked) {
      setBookingDataFormat({ ...BookingDataFormat, [P.date]: null, [P.time]: null });
    } else {
      setBookingDataFormat({ ...BookingDataFormat, [P.date]: moment(), [P.time]: moment() });
    }
  };

  return (
    <>
      {!transferConfirmation && (
        <Dialog open={open} maxWidth={false} className={classes.dialog}>
          {isMyAlert > 0 && (
            <MyAlert open={Boolean(isMyAlert)} text={alertText(isMyAlert)} type="success" onClose={closeMyAlert} />
          )}
          <div className={classes.root}>
            <Box display="flex" className={classes.header}>
              <Box display="flex" alignItems="baseline">
                <Typography className={baseClasses.headerTitle} style={{ padding: '1.3rem 0' }}>
                  {title}
                </Typography>
                <Typography className={classes.assignedBedNo} style={{ marginLeft: '4.563rem' }}>
                  <span className={classes.xing}>*</span>
                  {i18n.t('BEDSTATUS_FIELDS_ARE_REQUIRED')}
                </Typography>
              </Box>
              <IconButton className={baseClasses.closeIcon} onClick={closePop} style={{ marginRight: '-10px' }}>
                <CloseIcon />
              </IconButton>
            </Box>
            <main style={{ display: 'flex', overflow: 'auto', flex: '1', gap: '1.5rem', padding: '0 2.8rem' }}>
              <Box display="flex" flexDirection="column" flexBasis="50%" gridGap="0.642rem">
                <Box display="flex" alignItems="flex-start" gridGap="1.25rem">
                  <div className={classes.caseNoGroup}>
                    <Box width="50%">
                      <Typography
                        className={getCheckLableClasses(P.patienID)}
                        style={{ margin: '0rem 0rem 0.625rem 0', width: '100%' }}
                      >
                        {i18n.t('BEDSTATUS_PATIENT_ID')}
                        {/* <span className={classes.xing}>*</span> */}
                      </Typography>
                      <InputBase
                        id="bed_transferpop_patien"
                        className={classNames(classes.inputBase, getCheckInputClasses(P.patienID))}
                        value={BookingDataFormat[P.patienID]}
                        onChange={(event) => {
                          (async () => {
                            await onChangeHandle('up_text', P.patienID)(event);
                          })();
                        }}
                        style={{ width: '100%' }}
                        onBlur={() => {
                          (async () => {
                            await focusCheck(P.patienID)();
                          })();
                        }}
                        disabled={disabledData?.hospitalNo || statusDL}
                      />
                      {errorMsg?.[P.patienID] && (
                        <Typography className={classes.errorMsg}>{errorMsg[P.patienID]}</Typography>
                      )}
                    </Box>
                    <Box width="50%">
                      <Typography
                        className={getCheckLableClasses(P.hospitalCode)}
                        style={{ margin: '0rem 0 0.625rem 0', width: '100%' }}
                      >
                        {i18n.t('BEDSTATUS_HOSPITAL_CODE')}
                        <span className={classes.xing}>*</span>
                      </Typography>
                      <AutoCompleteInput2
                        id="bed_transferpop_hospitalcode"
                        itemList={_.map(BsHospcodeList, (item) => {
                          return { text: item, value: item };
                        })}
                        value={BookingDataFormat[P.hospitalCode]}
                        onChange={(event) => {
                          (async () => {
                            await onChangeHandle('select_hosp_code', P.hospitalCode)(event);
                          })();
                        }}
                        errorMsg={errorMsg?.[P.hospitalCode]}
                        onBlur={() => {
                          (async () => {
                            await focusCheck(P.hospitalCode)();
                          })();
                        }}
                        disabled={disabledData?.hospitalCode || statusDL}
                        freeSolo={true}
                      />
                    </Box>
                  </div>

                  <Box flex={1} pt="0.857rem" display="flex" gridGap="1.21rem">
                    <Box width="50%">
                      <Typography
                        className={getCheckLableClasses(P.hkid)}
                        style={{ margin: '0rem 0rem 0.57rem 0', width: '100%' }}
                      >
                        HKID / Doc. No.
                      </Typography>
                      <InputBase
                        id="bed_transferpop_patien"
                        // className={getCheckInputClasses(P.hkid)}
                        className={baseClasses.inputText}
                        value={BookingDataFormat[P.hkid]}
                        onChange={(event) => {
                          (async () => {
                            await onChangeHandle('text', P.hkid)(event);
                          })();
                        }}
                        style={{ width: '100%' }}
                        onBlur={() => {
                          (async () => {
                            await focusCheck(P.hkid)();
                          })();
                        }}
                      />
                      {Boolean(errorMsg?.[P.hkid]) && (
                        <Typography className={classes.errorMsg}>{errorMsg[P.hkid]}</Typography>
                      )}
                    </Box>
                    <Box width="50%" alignSelf="flex-start" mt="1.882rem">
                      <ButtonBase
                        id="bed_transferpop_retrieve"
                        className={classNames(baseClasses.bottomDeleteBtn, classes.buttonRetrieve)}
                        onClick={() => {
                          (async () => {
                            await retrieveClick();
                          })();
                        }}
                        style={{ height: '3.5rem', width: '100%' }}
                        disabled={disabledData?.retrieve || statusDL}
                      >
                        {i18n.t('BEDSTATUS_RETRIEVE')}
                      </ButtonBase>
                    </Box>
                  </Box>
                </Box>

                <Box display="flex" gridGap="1.25rem">
                  <Box width="25%">
                    <Typography className={getCheckLableClasses(P.name)} style={{ marginBottom: '0.571rem' }}>
                      Eng Name
                      <span className={classes.xing}>*</span>
                    </Typography>
                    <InputBase
                      id="bed_transferpop_name"
                      className={classNames(classes.inputBase, getCheckInputClasses(P.name))}
                      value={BookingDataFormat[P.name]}
                      onChange={(event) => {
                        (async () => {
                          await onChangeHandle('text', P.name)(event);
                        })();
                      }}
                      style={{ width: '100%' }}
                      onBlur={() => {
                        (async () => {
                          await focusCheck(P.name)();
                        })();
                      }}
                      disabled={disabledData?.name || statusDL}
                    />
                    {errorMsg?.[P.name] && <Typography className={classes.errorMsg}>{errorMsg[P.name]}</Typography>}
                  </Box>
                  <Box width="25%">
                    <Typography className={getCheckLableClasses(P.chiName)} style={{ marginBottom: '0.571rem' }}>
                      Chi. Name
                      {/* <span className={classes.xing}>*</span> */}
                    </Typography>
                    <InputBase
                      id="bed_transferpop_name"
                      className={classNames(
                        classes.inputBase,
                        getCheckInputClasses(P.chiName),
                        classes.chineseNameInput
                      )}
                      value={BookingDataFormat[P.chiName]}
                      onChange={(event) => {
                        (async () => {
                          await onChangeHandle('text', P.chiName)(event);
                        })();
                      }}
                      style={{ width: '100%' }}
                      onBlur={() => {
                        (async () => {
                          await focusCheck(P.chiName)();
                        })();
                      }}
                      disabled={disabledData?.chiName || statusDL}
                    />
                    {errorMsg?.[P.chiName] && (
                      <Typography className={classes.errorMsg}>{errorMsg[P.chiName]}</Typography>
                    )}
                  </Box>
                  <Box width="25%">
                    <Typography
                      className={getCheckLableClasses(P.age)}
                      style={{ width: '100%', marginBottom: '0.571rem' }}
                    >
                      {i18n.t('BEDSTATUS_AGE')}
                      <span className={classes.xing}>*</span>
                    </Typography>
                    <InputBase
                      id="bed_transferpop_age"
                      className={classNames(classes.inputBase, getCheckInputClasses(P.age))}
                      value={BookingDataFormat[P.age] ?? ''}
                      onChange={(event) => {
                        (async () => {
                          await onChangeHandle('text_positive_integer', P.age)(event);
                        })();
                      }}
                      style={{ width: '100%' }}
                      onBlur={() => {
                        (async () => {
                          await focusCheck(P.age)();
                        })();
                      }}
                      disabled={disabledData?.age || statusDL}
                    />
                    {errorMsg?.[P.age] && <Typography className={classes.errorMsg}>{errorMsg[P.age]}</Typography>}
                  </Box>
                  <Box minWidth="25%" maxWidth="11.063rem">
                    <Typography
                      className={getCheckLableClasses(P.specialtyCode)}
                      style={{ width: '100%', marginBottom: '0.571rem' }}
                    >
                      {i18n.t('BEDSTATUS_SPECIALTY_CODE')}
                    </Typography>
                    <InputBase
                      id="bed_transferpop_specialty_code"
                      className={classNames(classes.inputBase, baseClasses.inputText)}
                      placeholder={i18n.t('BEDSTATUS_SELECT_SPECIALTY_CODE')}
                      value={BookingDataFormat[P.specialtyCode]}
                      onChange={(event) => {
                        (async () => {
                          await onChangeHandle('text', P.specialtyCode)(event);
                        })();
                      }}
                      style={{ width: '100%' }}
                      disabled={disabledData?.specialtyCode || statusDL}
                    />
                  </Box>
                </Box>

                <Box display="flex" gridGap="1.25rem">
                  <Box width="33%">
                    <Typography className={getCheckLableClasses(P.gender)} style={{ marginBottom: '0.571rem' }}>
                      {i18n.t('BEDSTATUS_GENDER')}
                      <span className={classes.xing}>*</span>
                    </Typography>
                    <div>
                      <div className={classNames(baseClasses.gender, classes.gender)}>
                        <ButtonBase
                          id="bed_transferpop_male"
                          className={
                            BookingDataFormat[P.gender] === 'M'
                              ? classNames(baseClasses.genderBtn, baseClasses.selectGender, classes.genderBtnM)
                              : classNames(baseClasses.genderBtn, classes.genderBtn)
                          }
                          onClick={onGenderClick(P.gender, 'M')}
                          style={{ borderTopRightRadius: '0', borderBottomRightRadius: '0' }}
                          disabled={disabledData?.gender || statusDL}
                        >
                          {i18n.t('BEDSTATUS_MALE')}
                        </ButtonBase>
                        <ButtonBase
                          id="bed_transferpop_female"
                          className={
                            BookingDataFormat[P.gender] === 'F'
                              ? classNames(baseClasses.genderBtn, baseClasses.selectGender, classes.genderBtnF)
                              : classNames(baseClasses.genderBtn, classes.genderBtn)
                          }
                          onClick={onGenderClick(P.gender, 'F')}
                          style={{ borderTopLeftRadius: '0', borderBottomLeftRadius: '0' }}
                          disabled={disabledData?.gender || statusDL}
                        >
                          {i18n.t('BEDSTATUS_FEMALE')}
                        </ButtonBase>
                      </div>
                      {errorMsg?.[P.gender] && (
                        <Typography className={classes.errorMsg}>{errorMsg[P.gender]}</Typography>
                      )}
                    </div>
                  </Box>
                  <Box width="33%">
                    <Typography className={baseClasses.labelText} style={{ width: '100%', marginBottom: '0.571rem' }}>
                      {i18n.t('BEDSTATUS_WARD')}
                    </Typography>
                    <InputBase
                      id="bed_transferpop_ward"
                      className={classNames(classes.inputBase, baseClasses.inputText)}
                      value={BookingDataFormat[P.ward]}
                      onChange={(event) => {
                        (async () => {
                          await onChangeHandle('text', P.ward)(event);
                        })();
                      }}
                      style={{ width: '100%' }}
                      disabled={disabledData?.ward || statusDL}
                    />
                  </Box>
                  <Box width="33%">
                    <Typography className={baseClasses.labelText} style={{ width: '100%', marginBottom: '0.571rem' }}>
                      {i18n.t('BEDSTATUS_BED_NO')}
                    </Typography>
                    <InputBase
                      id="bed_transferpop_bed_no"
                      className={classNames(classes.inputBase, baseClasses.inputText)}
                      value={BookingDataFormat[P.bedNo]}
                      onChange={(event) => {
                        (async () => {
                          await onChangeHandle('text', P.bedNo)(event);
                        })();
                      }}
                      style={{ width: '100%' }}
                      disabled={disabledData?.bedNo || statusDL}
                    />
                  </Box>
                </Box>

                <Box>
                  <Box display="flex" mb="0.57rem">
                    {/* <Box width="20%" /> */}
                    <Box width="50%" marginRight="1.25rem">
                      <Typography className={getCheckLableClasses(P.date)}>
                        {i18n.t('BEDSTATUS_DATE')}
                        <span className={classes.xing}>*</span>
                      </Typography>
                    </Box>
                    <Box width="50%">
                      <Typography className={getCheckLableClasses(P.time)}>
                        {i18n.t('BEDSTATUS_TIME')}
                        <span className={classes.xing}>*</span>
                      </Typography>
                    </Box>
                  </Box>

                  <Box display="flex" alignItems="center">
                    {/* <Box width="20%">
                      <FormControlLabel
                        id="bed_transferpop_on_oxygen"
                        control={<Checkbox />}
                        label="Adm. Date"
                        className={baseClasses.checkBox}
                        checked={amdDateIsChecked}
                        onChange={handleCheckAmdDate}
                        disabled={allData?.status === 'PFYA' || statusDL}
                      />
                    </Box> */}
                    <Box width="50%" marginRight="1.25rem">
                      <KeyboardDatePicker
                        id="bed_transferpop_date"
                        autoOk
                        variant="inline"
                        inputVariant="outlined"
                        invalidDateMessage={null}
                        format="DD-MM-yyyy"
                        value={BookingDataFormat[P.date]}
                        className={classNames(
                          classes.datepicker,
                          classes.keyboardDatePicker,
                          (allData?.status === 'PFYA' || statusDL || amdDateIsChecked) && classes.disabledStyle
                        )}
                        keyboardIcon={
                          <div className={classNames(baseClasses.dateIcon, classes.dateIcon)}>
                            <DateIcon />
                          </div>
                        }
                        onChange={(event) => {
                          (async () => {
                            await onChangeHandle('date', P.date)(event);
                          })();
                        }}
                        placeholder={i18n.t('BEDSTATUS_TIME')}
                        disabled={allData?.status === 'PFYA' || statusDL || amdDateIsChecked}
                        style={{ width: '100%' }}
                      />
                      {!moment(BookingDataFormat[P.date]).isValid() && errorMsg?.[P.date] && (
                        <Typography className={classes.errorMsg}>{errorMsg[P.date]}</Typography>
                      )}
                    </Box>
                    <Box width="50%">
                      <KeyboardTimeInput
                        id="bed_transferpop_time"
                        className={classNames(classes.keyboardTimeInput)}
                        value={BookingDataFormat[P.time]}
                        placeholder={i18n.t('BEDSTATUS_SELECT_TIME')}
                        onChange={(event) => {
                          (async () => {
                            await onChangeHandle('date', P.time)(event);
                          })();
                        }}
                        disabled={allData?.status === 'PFYA' || statusDL || amdDateIsChecked}
                      />
                      {!moment(BookingDataFormat[P.time]).isValid() && errorMsg?.[P.time] && (
                        <Typography className={classes.errorMsg}>{errorMsg[P.time]}</Typography>
                      )}
                    </Box>
                  </Box>
                </Box>

                <Box display="flex" flexDirection="column" gridGap="0.5rem" className={classes.bgYellow}>
                  <Box>
                    <Box display="flex" gridGap="1.25rem" alignItems="flex-end">
                      <Box width="25%">
                        <Typography
                          className={getCheckLableClasses(P.destHospCode)}
                          style={{ margin: '0 0 0.571rem 0', width: '100%' }}
                        >
                          {i18n.t('BEDSTATUS_DEST_HOSPITAL')}
                          <span className={classes.xing}>*</span>
                        </Typography>
                      </Box>
                      <Box width="25%">
                        <Typography
                          className={getCheckLableClasses(P.destWardId)}
                          style={{ margin: '0 0 0.571rem 0', width: '100%' }}
                        >
                          {i18n.t('BEDSTATUS_DEST_WARD')}
                          <span className={classes.xing}>*</span>
                        </Typography>
                      </Box>
                      <Box width="25%">
                        <Typography
                          className={getCheckLableClasses(P.destWardLocation)}
                          style={{ margin: '0 0 0.571rem 0', width: '100%' }}
                        >
                          Dest. Ward Location
                          <span className={classes.xing}>*</span>
                        </Typography>
                      </Box>
                      <Box width="25%">
                        <Typography
                          className={getCheckLableClasses(P.admissionType)}
                          style={{ margin: '0 0 0.571rem 0', width: '100%' }}
                        >
                          {i18n.t('BEDSTATUS_ADMISSION_TYPE')}
                          <span className={classes.xing}>*</span>
                        </Typography>
                      </Box>
                    </Box>
                    <Box display="flex" gridGap="1.25rem">
                      <Box width="25%">
                        <AutoCompleteInput
                          id="bed_transferpop_dest_hospital"
                          itemList={destHospitalOption}
                          placeholder={i18n.t('BEDSTATUS_SELECT_FROM_BELOW_ITEMS')}
                          value={BookingDataFormat[P.destHospCode]}
                          onChange={(event) => {
                            (async () => {
                              await onChangeHandle('select_dest_hospital', P.destHospCode)(event);
                            })();
                          }}
                          errorMsg={errorMsg?.[P.destHospCode]}
                          onBlur={() => {
                            (async () => {
                              await focusCheck(P.destHospCode)();
                            })();
                          }}
                          className={classes.destSelect}
                          disabled={statusDL}
                        />
                      </Box>
                      <Box width="25%">
                        <AutoCompleteInput
                          id="bed_transferpop_dest_ward"
                          itemList={destUnitOptions}
                          placeholder={i18n.t('BEDSTATUS_SELECT_FROM_BELOW_ITEMS')}
                          value={BookingDataFormat[P.destWardId]}
                          onChange={(event) => {
                            (async () => {
                              await onChangeHandle('select_dest_unit', P.destWardId)(event);
                            })();
                          }}
                          errorMsg={errorMsg?.[P.destWardId]}
                          onBlur={() => {
                            (async () => {
                              await focusCheck(P.destWardId)();
                            })();
                          }}
                          className={classes.destSelect}
                          disabled={statusDL}
                        />
                      </Box>
                      <Box width="25%">
                        <AutoCompleteInput
                          id="bed_transferpop_dest_ward_location"
                          itemList={destWardLocationOptions}
                          placeholder={i18n.t('BEDSTATUS_SELECT_FROM_BELOW_ITEMS')}
                          value={BookingDataFormat[P.destWardLocation]}
                          onChange={(event) => {
                            (async () => {
                              await onChangeHandle('select', P.destWardLocation)(event);
                            })();
                          }}
                          errorMsg={errorMsg?.[P.destWardLocation]}
                          onBlur={() => {
                            (async () => {
                              await focusCheck(P.destWardLocation)();
                            })();
                          }}
                          disabled={statusDL}
                        />
                      </Box>
                      <Box width="25%">
                        <AutoCompleteSelect
                          id="bed_transferpop_admission_type"
                          itemList={getTransferInOutAdmissionTypeList(bsMlookupList)}
                          placeholder={i18n.t('BEDSTATUS_SELECT_FROM_BELOW_ITEMS')}
                          value={BookingDataFormat[P.admissionType]}
                          onChange={(event) => {
                            (async () => {
                              await onChangeHandle('select', P.admissionType)(event);
                            })();
                          }}
                          errorMsg={errorMsg?.[P.admissionType]}
                          onBlur={() => {
                            (async () => {
                              await focusCheck(P.admissionType)();
                            })();
                          }}
                          disabled={statusDL}
                          className={classes.destSelect}
                        />
                      </Box>
                    </Box>
                  </Box>
                  <Box>
                    <Typography
                      style={{ margin: '0 0 0.571rem 0' }}
                      className={getCheckLableClasses(P.principleDiagnosisText)}
                    >
                      {i18n.t('BEDSTATUS_PRINCIPLE_DIAGNOSIS')}
                      {/* <span className={classes.xing}>*</span> */}
                    </Typography>
                    <Box>
                      <TextField
                        id={P.principleDiagnosisText}
                        className={
                          errorMsg?.[P.principleDiagnosisText]
                            ? classNames(classes.textField, classes.inputError)
                            : classes.textField
                        }
                        multiline={true}
                        fullWidth={true}
                        rows={3}
                        value={BookingDataFormat?.[P.principleDiagnosisText]}
                        onChange={(event) => {
                          (async () => {
                            await onChangeHandle('text', P.principleDiagnosisText)(event);
                          })();
                        }}
                        // placeholder={i18n.t('BEDSTATUS_ADD_PRINCIPAL_DIAGNOSIS')}
                        style={{ backgroundColor: statusDL ? '#f5f5f5' : '' }}
                        disabled={statusDL}
                        onBlur={() => {
                          (async () => {
                            await focusCheck(P.principleDiagnosisText)();
                          })();
                        }}
                      />
                      {errorMsg?.[P.principleDiagnosisText] && (
                        <Typography className={classes.errorMsg}>{errorMsg[P.principleDiagnosisText]}</Typography>
                      )}
                    </Box>
                    <AutoCompleteMultiCheckbox2
                      // dropDownIcon={true}
                      align="right"
                      height="3.5rem"
                      width="100%"
                      errMsgMargin="3px 0 0 0.825rem"
                      errMsgWidth="11rem"
                      placeholder={i18n.t('BEDSTATUS_PRINCIPLE_DIAGNOSIS_PLACEHOLDER')}
                      itemList={BsDiagnosisListFrom}
                      open={BookingDataFormat[P.principleDiagnosisInputValue]?.length > 2}
                      inputValue={BookingDataFormat[P.principleDiagnosisInputValue]}
                      onChangeInputValue={(event) => {
                        (async () => {
                          await onChangeHandle('select', P.principleDiagnosisInputValue)(event);
                        })();
                        HandlerOnChangeBsDigKeyword(event);
                      }}
                      value={BookingDataFormat[P.principleDiagnosis]}
                      onChange={(event) => {
                        (async () => {
                          await onChangeHandle('select', P.principleDiagnosis)(event);
                        })();
                      }}
                      id="bed_transferpop_principle_diagnosis"
                      allText=""
                      onBlur={() => {
                        setTimeout(() => {
                          const newText = _.map(BookingDataFormat[P.principleDiagnosis], (item) => item.text);
                          setBookingDataFormat({
                            ...BookingDataFormat,
                            [P.principleDiagnosisInputValue]: '',
                            [P.principleDiagnosis]: [],
                            [P.principleDiagnosisText]: [BookingDataFormat[P.principleDiagnosisText], ...newText]
                              .filter(Boolean)
                              .join('\n'),
                          });
                        });
                      }}
                      disabled={statusDL}
                    />
                  </Box>
                </Box>

                <Box display="flex" paddingBottom="1rem" gridGap="1.25rem">
                  <Box width="35%">
                    <Typography className={baseClasses.labelText} style={{ margin: '0 0 0.571rem 0', width: '100%' }}>
                      {i18n.t('BEDSTATUS_DEST_SPECIALTY')}
                    </Typography>

                    <InputBase
                      id="bed_transferpop_bed_no"
                      className={classNames(baseClasses.inputText, classes.inputBase)}
                      value={BookingDataFormat[P.destSpecialty]}
                      onChange={(event) => {
                        (async () => {
                          await onChangeHandle('text', P.destSpecialty)(event);
                        })();
                      }}
                      style={{ width: '100%' }}
                      disabled={statusDL}
                    />
                  </Box>

                  <Box width="35%">
                    <Typography
                      className={getCheckLableClasses(P.wardCd)}
                      style={{ margin: '0 0 0.571rem 0', width: '100%' }}
                    >
                      {i18n.t('BEDSTATUS_ASSIGNED_WARD_CODE')}
                    </Typography>
                    <InputBase
                      id="bed_transferpop_admission_ward_code"
                      className={classNames(classes.inputBase, baseClasses.inputText)}
                      value={BookingDataFormat[P.wardCd]}
                      onChange={(event) => {
                        (async () => {
                          await onChangeHandle('text', P.wardCd)(event);
                        })();
                      }}
                      style={{ width: '100%' }}
                      disabled={true}
                    />
                  </Box>
                  <Box minWidth="30%" maxWidth="11.063rem">
                    <Typography
                      style={{ margin: '0 0 0.571rem 0', width: '100%' }}
                      className={getCheckLableClasses(P.assignedBedNo)}
                    >
                      {i18n.t('BEDSTATUS_ASSIGNED_BED_NO')}
                    </Typography>
                    <InputBase
                      id="bed_transferpop_assigned_bed_dno"
                      className={classNames(classes.inputBase, baseClasses.inputText)}
                      value={BookingDataFormat[P.assignedBedNo]}
                      onChange={(event) => {
                        (async () => {
                          await onChangeHandle('text', P.assignedBedNo)(event);
                        })();
                      }}
                      style={{ width: '100%' }}
                      disabled={true}
                    />
                  </Box>
                </Box>
              </Box>
              <div style={{ marginBottom: '1.625rem', width: '1px', background: '#e4e7eb' }} />
              <Box display="flex" flexDirection="column" flexBasis="50%">
                <Box mt="0.5rem">
                  <Box display="flex" alignItems="center">
                    <Typography className={baseClasses.rightLabel} style={{ marginRight: '0.5rem', color: '#7d86a9' }}>
                      {i18n.t('BEDSTATUS_ON_VENTILATOR')}
                    </Typography>
                    <AutoCompleteSelect
                      id="bed_transferpop_on_ventilator"
                      itemList={onVentilatorList()}
                      placeholder={i18n.t('BEDSTATUS_SELECT_FROM_BELOW_ITEM')}
                      value={BookingDataFormat[P.onVentilator]}
                      onChange={(event) => {
                        (async () => {
                          await onChangeHandle('select', P.onVentilator)(event);
                        })();
                      }}
                      disabled={statusDL}
                    />
                    <TextField
                      id="bed_transferpop_eg7"
                      variant="outlined"
                      className={classNames(baseClasses.inputText, baseClasses.eg7)}
                      InputProps={{
                        endAdornment: <Typography className={baseClasses.LIcon}>%</Typography>,
                      }}
                      placeholder="eg. 7"
                      value={BookingDataFormat[P.egPercent]}
                      onChange={(event) => {
                        (async () => {
                          await onChangeHandle('text', P.egPercent)(event);
                        })();
                      }}
                      style={{ width: '40%', marginLeft: '0.5rem', backgroundColor: statusDL ? '#f5f5f5' : '' }}
                      type="number"
                      step="0.1"
                      disabled={statusDL}
                    />
                  </Box>
                </Box>
                <div>
                  <Box display="flex" m="0.5rem 0 0.5rem 0" alignItems="center">
                    <FormControlLabel
                      id="bed_transferpop_on_oxygen"
                      control={<Checkbox disabled={statusDL} className={classes.checkbox} />}
                      label={i18n.t('BEDSTATUS_ON_OXYGEN')}
                      className={classNames(baseClasses.checkBox)}
                      checked={Boolean(BookingDataFormat[P.onOxygen])}
                      onChange={(event) => {
                        (async () => {
                          await onChangeHandle('check', P.onOxygen)(event);
                        })();
                      }}
                    />
                    <TextField
                      id="bed_transferpop_egL"
                      variant="outlined"
                      className={classNames(baseClasses.inputText, baseClasses.eg7)}
                      InputProps={{
                        endAdornment: <Typography className={baseClasses.LIcon}>L</Typography>,
                      }}
                      placeholder="eg. 7"
                      disabled={!BookingDataFormat.onOxygen}
                      value={BookingDataFormat[P.egL]}
                      onChange={(event) => {
                        (async () => {
                          await onChangeHandle('text', P.egL)(event);
                        })();
                      }}
                      style={{ width: '30%', marginRight: '0.5rem', backgroundColor: statusDL ? '#f5f5f5' : '' }}
                      type="number"
                      step="0.1"
                    />
                    <div style={{ marginLeft: '1.5rem' }}>
                      <FormControlLabel
                        id="bed_transferpop_tracheotomy"
                        control={<Checkbox disabled={statusDL} className={classes.checkbox} />}
                        label={i18n.t('BEDSTATUS_TRACHEOTOMY')}
                        className={baseClasses.checkBox}
                        checked={Boolean(BookingDataFormat[P.tracheotomy])}
                        onChange={(event) => {
                          (async () => {
                            await onChangeHandle('check', P.tracheotomy)(event);
                          })();
                        }}
                        disabled={statusDL}
                      />
                    </div>
                  </Box>
                </div>
                <div>
                  <Box display="flex" m="0.15rem 0 0 0" justifyContent="space-between">
                    <Box width="100%">
                      <AddTextInput
                        btnId="bed_transferpop_attention_btn"
                        textId="bed_transferpop_attention_input"
                        popId="bed_transferpop_attention_pop"
                        allData={bsAttentionFunc.getNameList(BsAttentionList)}
                        title={
                          <Typography
                            className={classes.remarks}
                            style={{ margin: '0rem 0 0.575rem 0', color: '#7d86a9' }}
                          >
                            {i18n.t('BEDSTATUS_ATTENTION')}
                          </Typography>
                        }
                        btnText={
                          <Typography className={classes.addRemarks}>
                            <AddIcon className={classes.addIcon} />
                            {i18n.t('BEDSTATUS_ADD_ATTENTION')}
                          </Typography>
                        }
                        onChange={(event) => {
                          (async () => {
                            await onChangeHandle('select', P.attention)(event);
                          })();
                        }}
                        value={BookingDataFormat[P.attention]}
                        popClassName={classes.addTextInput}
                        rows={6}
                        errorMsg={errorMsg?.[P.attention]}
                        onBlur={() => {
                          (async () => {
                            await focusCheck(P.attention)();
                          })();
                        }}
                        disabled={statusDL}
                      />
                    </Box>
                  </Box>
                </div>
                {Boolean(BookingDataFormat[P.covid19]) && (
                  <Box width="100%">
                    <div className={classes.covidDetail}>
                      <Box display="flex" flexDirection="column">
                        <Typography className={classes.covidDetailTitle}>
                          {i18n.t('BEDSTATUS_COVID_19_DETAIL')}
                        </Typography>
                        <Box display="flex">
                          <Box width="50%" mr="1rem">
                            <Typography className={baseClass.labelText} style={{ marginBottom: '0.25rem' }}>
                              {i18n.t('BEDSTATUS_DETECTED_DATE')} <span className={classes.xing}>*</span>
                            </Typography>
                            <Box>
                              <KeyboardDatePicker
                                id="bed_transferpop_date"
                                autoOk
                                variant="inline"
                                inputVariant="outlined"
                                invalidDateMessage={null}
                                format="DD-MM-YYYY"
                                value={BookingDataFormat[P.covidDate]}
                                className={classNames(classes.datepicker, classes.keyboardDatePicker)}
                                keyboardIcon={
                                  <div className={classNames(baseClasses.dateIcon, classes.dateIcon)}>
                                    <DateIcon />
                                  </div>
                                }
                                onChange={(event) => {
                                  (async () => {
                                    await onChangeHandle('date', P.covidDate)(event);
                                  })();
                                }}
                                placeholder={i18n.t('BEDSTATUS_DATE')}
                                disableFuture={true}
                              />
                            </Box>
                          </Box>
                          <Box width="50%">
                            <Typography className={baseClass.labelText} style={{ marginBottom: '0.25rem' }}>
                              {i18n.t('BEDSTATUS_COUNTER_TRANSFER')}
                            </Typography>
                            <TextField
                              id="bed_transferpop_counter"
                              variant="outlined"
                              className={classNames(baseClasses.inputText, baseClasses.eg7)}
                              InputProps={{
                                endAdornment: (
                                  <Typography className={baseClasses.LIcon} style={{ color: '#2e4469' }}>
                                    {i18n.t('BEDSTATUS_DAY')}
                                  </Typography>
                                ),
                              }}
                              style={{ width: '100%', backgroundColor: '#f5f5f5', color: '#2e4469' }}
                              disabled={true}
                              placeholder=""
                              value={counter}
                              onChange={(event) => {
                                (async () => {
                                  await onChangeHandle('text', P.counter)(event);
                                })();
                              }}
                              type="number"
                              step="0.1"
                            />
                          </Box>
                        </Box>
                      </Box>
                    </div>
                  </Box>
                )}
                <AddTextInput
                  btnId="bed_transferpop_remarks_btn"
                  textId="bed_transferpop_remarks_input"
                  popId="bed_transferpop_remarks_pop"
                  allData={remarkList}
                  title={
                    <Typography className={classes.remarks} style={{ margin: '0rem 0 0.438rem 0', color: '#7d86a9' }}>
                      {i18n.t('BEDSTATUS_REMARKS')}
                    </Typography>
                  }
                  btnText={
                    <Typography className={classes.addRemarks}>
                      <AddIcon className={classes.addIcon} />
                      {i18n.t('BEDSTATUS_ADD_REMARKS')}
                    </Typography>
                  }
                  value={BookingDataFormat[P.remarks]}
                  onChange={(event) => {
                    (async () => {
                      await onChangeHandle('select', P.remarks)(event);
                    })();
                  }}
                  style={{ marginTop: '.875rem' }}
                  rows={3}
                  errorMsg={errorMsg?.[P.remarks]}
                  onBlur={() => {
                    (async () => {
                      await focusCheck(P.remarks)();
                    })();
                  }}
                  disabled={statusDL}
                />
                <Box display="flex" gridGap="0.5rem" m="0.5rem 0">
                  <Box width="50%">
                    <Text color="#7d86a9" fontSize="1rem">
                      MDRO Alert / CMS Alert
                    </Text>
                    {isNotEmptyArray(patientStatusData?.[bedP?.mdroInfo]) ||
                    isNotEmptyArray(patientStatusData?.[bedP?.cmsAlertInfos]) ? (
                      <>
                        <Box display="flex" flexWrap="wrap" mt="0.62rem" gridGap="0.62rem">
                          {patientStatusData?.[bedP?.mdroInfo]?.map((item) => (
                            <MdroInfo content={item.alertDesc} key={item.alertDesc} popValue={item} />
                          ))}
                        </Box>
                        <CmsAlert
                          alertsData={patientStatusData?.[bedP?.cmsAlertInfos]}
                          variant={CMS_ALERT_ICON_VARIANT.WIDE}
                        />
                      </>
                    ) : (
                      '--'
                    )}
                  </Box>
                  <Box width="50%">
                    <Text color="#7d86a9" fontSize="1rem">
                      {i18n.t('ELDERLY_HOME')}
                    </Text>
                    <ElderlyHomeInfo
                      containerClass={classes.elderlyHomeInfo}
                      ehAddrInfo={patientStatusData?.[bedP?.elderlyHome]}
                      emptyIcon="--"
                    />
                  </Box>
                </Box>
                <Box width="100%" marginRight="1.25rem" paddingBottom="0.5rem">
                  <Typography className={getCheckLableClasses(P.status)} style={{ margin: '0rem 0 0.438rem 0' }}>
                    {i18n.t('BEDSTATUS_STATUS')} <span className={classes.xing}>*</span>
                  </Typography>
                  <AutoCompleteSelect
                    id="bed_transferpop_status"
                    itemList={listOption}
                    placeholder={i18n.t('BEDSTATUS_SELECT_FROM_BELOW_ITEMS')}
                    value={BookingDataFormat[P.status]}
                    onChange={(event) => {
                      (async () => {
                        await onChangeHandle('select', P.status)(event);
                      })();
                    }}
                    errorMsg={errorMsg?.[P.status]}
                    onBlur={() => {
                      (async () => {
                        await focusCheck(P.status)();
                      })();
                    }}
                    disabled={
                      ['PFYA', 'DL', 'D', 'C', 'RWR'].includes(allData?.status) ||
                      transferOutSchema?.status ||
                      disabledStatus ||
                      statusIsA
                    }
                  />
                </Box>
                <Box width="50%" />
                {statusDL && (
                  <Box
                    display="flex"
                    flexDirection="column"
                    className={classNames(classes.message, classes.messageRed)}
                  >
                    <Typography className={classNames(classes.messageStatus, classes.messageStatusRed)}>
                      <NoticeIcon className={classes.messageIcon} /> {i18n.t('BEDSTATUS_YOUR_REQUES_IS_DECLINED')}
                    </Typography>
                    <Typography className={classes.messageTitle}>{i18n.t('BEDSTATUS_DECLINE_REMARKS')}</Typography>
                    <Typography className={classes.messageText}>{allData?.declineRemark}</Typography>
                  </Box>
                )}
                {statusIsA &&
                  allData?.targetArriveDtm &&
                  allData?.requestDtm &&
                  moment(allData?.targetArriveDtm).format('DD-MM-yyyy hh:mm') !==
                    moment(allData?.requestDtm).format('DD-MM-yyyy hh:mm') && (
                    <Box
                      display="flex"
                      flexDirection="column"
                      className={classNames(classes.message, classes.messageYellow)}
                    >
                      <Typography className={classNames(classes.messageStatus, classes.messageStatusYellow)}>
                        <AcceptIcon className={classes.messageIcon} /> {i18n.t('BEDSTATUS_TRANSFER_ACCEPTED')}
                      </Typography>
                      <Typography className={classes.messageTitle}>
                        {i18n.t('BEDSTATUS_CHANGED_ADMISSION_DATE_TIME')}
                      </Typography>
                      <Typography className={classes.messageText}>
                        {moment(allData?.requestDtm).format('DD-MM-yyyy hh:mm a')}
                      </Typography>
                    </Box>
                  )}
                {statusIsA &&
                  allData?.targetArriveDtm &&
                  allData?.requestDtm &&
                  moment(allData?.targetArriveDtm).format('DD-MM-yyyy hh:mm') ===
                    moment(allData?.requestDtm).format('DD-MM-yyyy hh:mm') && (
                    <Box
                      display="flex"
                      flexDirection="column"
                      className={classNames(classes.message, classes.messageGreen)}
                    >
                      <Typography className={classNames(classes.messageStatus, classes.messageStatuGreen)}>
                        <AcceptIcon className={classes.messageIcon} /> {i18n.t('BEDSTATUS_TRANSFER_ACCEPTED')}
                      </Typography>
                      <Typography className={classes.messageTitle}>
                        {i18n.t('BEDSTATUS_ADMISSION_DATE_TIME')}
                      </Typography>
                      <Typography className={classes.messageText}>
                        {moment(allData?.requestDtm).format('DD-MM-yyyy hh:mm a')}
                      </Typography>
                    </Box>
                  )}
              </Box>
            </main>
            <div style={{ borderTop: '1px solid #e4e7eb' }}>
              <div className={baseClasses.bottom} style={{ marginTop: '0.5rem' }}>
                {statusDL ? (
                  <>
                    <ButtonBase
                      id="bed_transferpop_decline"
                      className={baseClasses.bottomDeleteBtn}
                      onClick={canelHandler}
                      style={{ marginRight: '1.25rem' }}
                    >
                      {i18n.t('BEDSTATUS_CANCEL')}
                    </ButtonBase>
                    <ButtonBase
                      id="bed_transferpop_accept"
                      className={baseClasses.bottomSaveBtn}
                      onClick={redirectToOtherWardHandler}
                    >
                      {i18n.t('BEDSTATUS_REDIRECT_TO_OTHER_WARD')}
                    </ButtonBase>
                  </>
                ) : (
                  <>
                    <ButtonBase
                      id="bed_transferpop_cancel"
                      className={baseClasses.bottomDeleteBtn}
                      style={{ marginRight: '1.25rem' }}
                      onClick={canelHandler}
                    >
                      {i18n.t('BEDSTATUS_CANCEL')}
                    </ButtonBase>

                    {sendBtn ? (
                      <ButtonBase
                        id="bed_transferpop_save"
                        className={classNames(
                          baseClasses.bottomSaveBtn,
                          classes.buttonBase,
                          statusIsA && classes.disabledStyle
                        )}
                        onClick={() => {
                          (async () => {
                            await sendClick();
                          })();
                        }}
                        disabled={statusIsA}
                      >
                        {i18n.t('BEDSTATUS_SEND')}
                      </ButtonBase>
                    ) : (
                      <ButtonBase
                        id="bed_transferpop_save"
                        className={classNames(
                          baseClasses.bottomSaveBtn,
                          classes.buttonBase,
                          saveBtnDisabled(allData?.status) && classes.disabledStyle
                        )}
                        onClick={() => {
                          (async () => {
                            await saveClick();
                          })();
                        }}
                        disabled={saveBtnDisabled(allData?.status)}
                      >
                        {i18n.t('BEDSTATUS_SEND')}
                      </ButtonBase>
                    )}
                  </>
                )}
                {['A', 'RWR'].includes(allData?.status) && (
                  <ButtonBase
                    id="bed_transferpop_Deleted"
                    className={baseClasses.bottomDeleteBtn}
                    style={{ marginLeft: '1.25rem', borderColor: '#ff7270', color: '#fff', backgroundColor: '#ff7270' }}
                    onClick={deletedHandler}
                  >
                    {i18n.t('BEDSTATUS_DELETED_BTN')}
                  </ButtonBase>
                )}
              </div>
            </div>
          </div>
        </Dialog>
      )}
      {transferConfirmation && (
        <TransferConfirmation
          open={transferConfirmation}
          confirmHandle={() => {
            (async () => {
              await saveClick();
            })();
          }}
          closePop={closePopTransferConfirmation}
        />
      )}
    </>
  );
}
